import { clsx, type ClassValue } from 'clsx'
import { twMerge, extendTailwindMerge } from 'tailwind-merge'
import { shallow } from 'zustand/shallow'

export const tw = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'body-s',
            'body-s-emphasized',
            'body-m',
            'body-m-emphasized',
            'body-l',
            'body-l-emphasized',
            'body-xl',
            'body-xl-emphasized',
            'heading-s',
            'heading-m',
            'heading-l',
            'heading-xl',
            'label-xs',
            'label-s',
            'label-m',
            'label-l',
            'label-xl',
            'page',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs))
}

export function createMemoizedSelector<TDeps extends Array<unknown>, TResult>(
  selector: (...deps: TDeps) => TResult,
  depsFn: () => TDeps
): () => TResult
export function createMemoizedSelector<
  TArgs extends Array<unknown>,
  TDeps extends Array<unknown>,
  TResult
>(
  selector: (...deps: TDeps) => TResult,
  depsFn: (...args: TArgs) => TDeps
): (...args: TArgs) => TResult
export function createMemoizedSelector(
  selector: (...deps: Array<unknown>) => unknown,
  depsFn: (...args: Array<unknown>) => Array<unknown>
): (...args: Array<unknown>) => unknown {
  let prevDeps: Array<unknown> | undefined
  let cachedResult: unknown

  return (...args: Array<unknown>) => {
    const deps = depsFn(...args)
    if (prevDeps === undefined || !shallow(prevDeps, deps)) {
      prevDeps = deps
      cachedResult = selector(...deps)
    }

    return cachedResult
  }
}
